import React from 'react';
import { Card } from '../Card';

export function SocialFeedItemSkeleton() {
  return (
    <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100 mb-4">
      <div className="flex items-center space-x-3 mb-5">
        <div className="w-12 h-12 rounded-full bg-blue-100 animate-pulse"></div>
        <div className="flex-1">
          <div className="h-5 w-16 bg-gray-200 rounded-md animate-pulse mb-2"></div>
          <div className="h-4 w-32 bg-gray-200 rounded-md animate-pulse"></div>
        </div>
      </div>
      
      <div className="space-y-2 mb-4">
        <div className="h-4 bg-gray-200 rounded-md animate-pulse w-full"></div>
        <div className="h-4 bg-gray-200 rounded-md animate-pulse w-5/6"></div>
      </div>

      {/* Post Image Skeleton */}
      <div className="h-72 bg-gray-200 rounded-md animate-pulse mb-4"></div>
      
      <div className="flex justify-between items-center pt-2">
        <div className="flex items-center space-x-1">
          <div className="h-5 w-5 rounded-full bg-gray-200 animate-pulse"></div>
          <div className="h-4 w-6 bg-gray-200 rounded-md animate-pulse"></div>
        </div>
        <div className="flex items-center space-x-1">
          <div className="h-5 w-5 rounded-full bg-gray-200 animate-pulse"></div>
          <div className="h-4 w-6 bg-gray-200 rounded-md animate-pulse"></div>
        </div>
        <div className="flex items-center space-x-1">
          <div className="h-5 w-5 rounded-full bg-gray-200 animate-pulse"></div>
          <div className="h-4 w-6 bg-gray-200 rounded-md animate-pulse"></div>
        </div>
      </div>
    </div>
  );
}

export function SocialFeedListSkeleton() {
  return (
    <div className="px-4 flex flex-col gap-2">
      <SocialFeedItemSkeleton />
      <SocialFeedItemSkeleton />
    </div>
  );
}

const SocialFeedSkeleton = () => {
  return (
    <Card className="flex-1 pb-4">
      {/* Feed Header Skeleton */}
      <h3 className="py-6 px-4 font-bold">Feed</h3>

      {/* Post Input Skeleton */}
      <div className="mb-4 px-4 bg-white rounded-lg shadow-sm">
        <div className="h-24 bg-gray-200 rounded-md animate-pulse mb-3"></div>
        <div className="flex justify-between items-center p-3">
          <div className="flex space-x-3">
            <div className="h-6 w-28 bg-gray-200 rounded-md animate-pulse"></div>
            <div className="h-6 w-20 bg-gray-200 rounded-md animate-pulse"></div>
            <div className="h-6 w-24 bg-gray-200 rounded-md animate-pulse"></div>
          </div>
          <div className="h-9 w-20 bg-blue-200 rounded-lg animate-pulse"></div>
        </div>
      </div>

      {/* Feed Filters Skeleton */}
      <div className="pt-4 pb-3 overflow-x-auto">
        <div className="px-4 flex space-x-2">
          {[1, 2].map((item) => (
            <div 
              key={item} 
              className="h-8 w-24 bg-gray-200 rounded-full animate-pulse"
            ></div>
          ))}
        </div>
      </div>

      <SocialFeedListSkeleton />
    </Card>
  );
};

export default SocialFeedSkeleton;